import type { SiteConfig } from '@/hooks/useSiteConfig';

export const defaultSiteConfig: SiteConfig = {
  version: 11,
  logo: 'https://public.readdy.ai/ai/img_res/84307c24-168c-4044-910d-f492d7fb5c09.png',
  logoWidth: 380,
  logoHeight: 86,
  heroStyle: {
    paddingTop: 40, paddingBottom: 64, gap: 24, maxWidth: 896,
    titleSize: 36, subtitleSize: 16, labelSize: 14,
  },
  howItWorksStyle: {
    paddingTop: 80, paddingBottom: 80, gap: 24, maxWidth: 1024,
    titleSize: 30, subtitleSize: 14, labelSize: 14,
    bgColor: '#f9fafb',
  },
  featuresStyle: {
    paddingTop: 80, paddingBottom: 80, gap: 40, maxWidth: 1024,
    titleSize: 30, subtitleSize: 14, labelSize: 14,
  },
  statsStyle: {
    paddingTop: 64, paddingBottom: 64, gap: 24, maxWidth: 1024,
    titleSize: 30, subtitleSize: 14, labelSize: 14,
    bgColor: '#10b981',
  },
  screenshotsStyle: {
    paddingTop: 80, paddingBottom: 80, gap: 16, maxWidth: 1024,
    titleSize: 30, subtitleSize: 14, labelSize: 14,
    bgColor: '#f9fafb',
  },
  testimonialsStyle: {
    paddingTop: 80, paddingBottom: 80, gap: 24, maxWidth: 1024,
    titleSize: 30, subtitleSize: 14, labelSize: 14,
  },
  pricingStyle: {
    paddingTop: 80, paddingBottom: 80, gap: 24, maxWidth: 1024,
    titleSize: 30, subtitleSize: 14, labelSize: 14,
    bgColor: '#f9fafb',
  },
  faqStyle: {
    paddingTop: 80, paddingBottom: 80, gap: 24, maxWidth: 1024,
    titleSize: 30, subtitleSize: 14, labelSize: 14,
  },
  contactStyle: {
    paddingTop: 80, paddingBottom: 80, gap: 24, maxWidth: 1024,
    titleSize: 30, subtitleSize: 14, labelSize: 14,
    bgColor: '#f9fafb',
  },
  footerStyle: {
    paddingTop: 56, paddingBottom: 56, gap: 32, maxWidth: 1024,
    titleSize: 14, subtitleSize: 12, labelSize: 12,
    bgColor: '#f3f4f6',
  },
  nav: {
    howItWorks: 'Cách hoạt động',
    features: 'Tính năng',
    pricing: 'Bảng giá',
    contact: 'Liên hệ',
  },
  // --- NEW simple homepage defaults ---
  simpleNav: [
    { label: 'Trang chủ', href: '/' },
    { label: 'Giới thiệu', href: '/#gioi-thieu' },
    { label: 'Tin tức', href: '/#tin-tuc' },
    { label: 'Khuyến mãi', href: '/#khuyen-mai' },
    { label: 'Liên hệ', href: '/#lien-he' },
  ],
  simpleBanner: {
    images: [
      'https://storage.readdy-site.link/project_files/b76e2517-3017-41c1-b5e9-94231aad9ced/cae71fed-7ef5-45be-97fb-ca8561c89c6a_photo_6338959790452707203_y.jpg?v=36a87b5f09ee775abc1e547872420a2c',
      'https://storage.readdy-site.link/project_files/b76e2517-3017-41c1-b5e9-94231aad9ced/793285dc-d0c8-49da-8ff4-811e4c40bc07_photo_6338959790452707204_y.jpg?v=e69a975668ff0e65ea6bb131a8378cfa',
      'https://storage.readdy-site.link/project_files/b76e2517-3017-41c1-b5e9-94231aad9ced/98d81a87-e0b0-4bc6-a959-fc408bf47382_photo_6338959790452707206_y.jpg?v=efa5b38e66cc1f1666bff24635e77279',
      'https://storage.readdy-site.link/project_files/b76e2517-3017-41c1-b5e9-94231aad9ced/d78d68f3-3271-4352-8ead-b9f76c23b8c9_2f63231d-2137-4f79-8797-ddbedd70c6d0.png?v=0b1dc0ed6525be51345000060f67f6a6',
    ],
    alt: 'Banner chính',
    link: '/dang-ky',
    autoPlay: true,
    interval: 4000,
  },
  simpleContent: {
    sections: [
      {
        id: 'gioi-thieu',
        label: 'Về chúng tôi',
        title: 'Giới thiệu',
        articles: [
          {
            title: 'Giới thiệu tổng quan',
            content: 'Chúng tôi là nền tảng hàng đầu cung cấp dịch vụ giải trí trực tuyến chất lượng cao. Với nhiều năm kinh nghiệm trong ngành, chúng tôi cam kết mang đến cho người dùng những trải nghiệm tuyệt vời nhất.',
            image: 'https://storage.readdy-site.link/project_files/b76e2517-3017-41c1-b5e9-94231aad9ced/793285dc-d0c8-49da-8ff4-811e4c40bc07_photo_6338959790452707204_y.jpg?v=e69a975668ff0e65ea6bb131a8378cfa',
          },
          {
            title: 'Tầm nhìn và sứ mệnh',
            content: 'Tầm nhìn của chúng tôi là trở thành nền tảng giải trí trực tuyến hàng đầu khu vực. Sứ mệnh của chúng tôi là cung cấp dịch vụ an toàn, công bằng và minh bạch cho mọi người dùng.',
          },
        ],
      },
      {
        id: 'tin-tuc',
        label: 'Tin tức mới',
        title: 'Tin tức',
        articles: [
          {
            title: 'Thông báo quan trọng',
            content: 'Hệ thống vừa được nâng cấp với nhiều tính năng mới, giao diện thân thiện hơn và tốc độ xử lý nhanh hơn. Người dùng có thể trải nghiệm ngay từ hôm nay.',
            image: 'https://storage.readdy-site.link/project_files/b76e2517-3017-41c1-b5e9-94231aad9ced/98d81a87-e0b0-4bc6-a959-fc408bf47382_photo_6338959790452707206_y.jpg?v=efa5b38e66cc1f1666bff24635e77279',
          },
          {
            title: 'Cập nhật bảo mật',
            content: 'Chúng tôi luôn đặt bảo mật của người dùng lên hàng đầu. Hệ thống mã hóa SSL 256-bit và xác thực hai lớp đảm bảo mọi thông tin cá nhân luôn được bảo vệ tuyệt đối.',
          },
        ],
      },
      {
        id: 'khuyen-mai',
        label: 'Khuyến mãi',
        title: 'Khuyến mãi đặc biệt',
        articles: [
          {
            title: 'Ưu đãi thành viên mới',
            content: 'Đăng ký tài khoản mới ngay hôm nay để nhận ngay nhiều phần quà hấp dẫn. Chương trình chỉ áp dụng trong thời gian có hạn.',
            image: 'https://storage.readdy-site.link/project_files/b76e2517-3017-41c1-b5e9-94231aad9ced/d78d68f3-3271-4352-8ead-b9f76c23b8c9_2f63231d-2137-4f79-8797-ddbedd70c6d0.png?v=0b1dc0ed6525be51345000060f67f6a6',
          },
          {
            title: 'Hoàn trả hàng ngày',
            content: 'Chương trình hoàn trả không giới hạn dành cho tất cả thành viên. Mỗi ngày đều có cơ hội nhận hoàn trả lên đến mức hấp dẫn.',
          },
        ],
      },
    ],
  },
  // --- END NEW ---
  hero: {
    title: 'Hãy xây dựng sản phẩm của bạn bằng ứng dụng Appexy.',
    subtitle: 'Nhưng quả thực, cả hai chúng ta đều buộc tội và đưa ra những kẻ đáng bị căm ghét, những kẻ bị nhu nhược và hư hỏng bởi sự tâng bốc của những thú vui hiện tại, những kẻ phải chịu đau đớn và rắc rối, và những điều tương tự, là do lỗi của chúng ta đã không chu cấp.',
    buttonText: 'Hãy bắt đầu',
    phoneImage: 'https://salekit.page/assets/images/appexy/phones.png',
    logoImage: 'https://salekit.page/assets/images/logo/logo.png',
  },
  howItWorks: {
    label: 'Appexy hoạt động như thế nào',
    title: 'LÀM THẾ NÀO NÓ HOẠT ĐỘNG ?',
    subtitle: 'Nhưng để bạn có thể thấy tất cả lỗi này đã phát sinh từ đâu, tôi sẽ mở vấn đề cho những người buộc tội niềm vui và nỗi đau.',
    items: [
      {
        title: '1. Trình chỉnh sửa trực quan',
        description: 'Vì không ai ghét đau đớn vì bản thân nó là niềm vui.',
        icon: 'ri-edit-line',
      },
      {
        title: '2. Bộ sưu tập thiết kế khổng lồ',
        description: 'Vì không ai ghét đau đớn vì bản thân nó là niềm vui.',
        icon: 'ri-gallery-line',
      },
      {
        title: '3. Cài đặt bằng một cú nhấp chuột',
        description: 'Vì không ai ghét đau đớn vì bản thân nó là niềm vui.',
        icon: 'ri-download-line',
      },
    ],
  },
  features: {
    label: 'Các tính năng của Appexy',
    title: 'Giải pháp thông minh cho người mua',
    subtitle: 'Nhưng để bạn có thể thấy tất cả lỗi này đã phát sinh từ đâu, tôi sẽ mở vấn đề cho những người buộc tội niềm vui và nỗi đau.',
    items: [
      {
        title: 'Khám phá điểm đến của bạn',
        description: 'Mặt khác, chúng tôi tố cáo với sự phẫn nộ chính đáng đến mức mù quáng đến mức họ không thể.',
        bullets: [
          'Do đó, người khôn ngoan luôn giữ trong chúng ta vấn đề đối với nguyên tắc này là sự lựa chọn và từ chối những thú vui.',
          'Nhưng hãy để tất cả lỗi lầm bẩm sinh của những người tố cáo và nỗi đau của những người khen ngợi thấy.',
          'Và thực sự, việc phân biệt mọi thứ rất dễ dàng và phù hợp trong thời gian rảnh rỗi của chúng ta.',
        ],
        image: 'https://salekit.page/assets/images/appexy/feature1.png',
        imagePosition: 'left',
      },
      {
        title: 'Kết nối mọi người, địa điểm',
        description: 'Mặt khác, chúng tôi tố cáo với sự phẫn nộ chính đáng đến mức mù quáng đến mức họ không thể.',
        bullets: [
          'Do đó, người khôn ngoan luôn giữ trong chúng ta vấn đề đối với nguyên tắc này là sự lựa chọn và từ chối những thú vui.',
          'Nhưng hãy để tất cả lỗi lầm bẩm sinh của những người tố cáo và nỗi đau của những người khen ngợi thấy.',
          'Và thực sự, việc phân biệt mọi thứ rất dễ dàng và phù hợp trong thời gian rảnh rỗi của chúng ta.',
        ],
        image: 'https://salekit.page/assets/images/appexy/feature2.png',
        imagePosition: 'right',
      },
    ],
  },
  stats: {
    items: [
      { value: '825', label: 'GLOBAL BRANDS' },
      { value: '1800+', label: 'HAPPY CLIENTS' },
      { value: '599+', label: 'CREATIVE IDEA' },
      { value: '2000+', label: 'USER CLIENTS' },
    ],
  },
  screenshots: {
    label: 'Màn hình ứng dụng của Appexy',
    title: 'Ảnh chụp màn hình tuyệt vời',
    subtitle: 'Nhưng để bạn có thể thấy tất cả lỗi này đã phát sinh từ đâu, tôi sẽ mở vấn đề cho những người buộc tội niềm vui và nỗi đau.',
    items: [
      { image: 'https://salekit.page/assets/images/appexy/screen1.png', alt: 'Screen 1' },
      { image: 'https://salekit.page/assets/images/appexy/screen2.png', alt: 'Screen 2' },
      { image: 'https://salekit.page/assets/images/appexy/screen3.png', alt: 'Screen 3' },
      { image: 'https://salekit.page/assets/images/appexy/screen4.png', alt: 'Screen 4' },
      { image: 'https://salekit.page/assets/images/appexy/screen5.png', alt: 'Screen 5' },
    ],
  },
  testimonials: {
    label: 'OUR TESTIMONIAL',
    title: 'Khách hàng của chúng tôi nói gì',
    subtitle: 'Nhưng để bạn có thể thấy tất cả lỗi này đã phát sinh từ đâu, tôi sẽ mở vấn đề cho những người buộc tội niềm vui và nỗi đau.',
    items: [
      { quote: '"Và vì vậy, chúng tôi trong số họ được giữ bởi một lựa chọn khôn ngoan, đẩy lùi những kẻ khó khăn hơn."', name: 'Mayra Vasquez', role: 'Web Development, USA', avatar: 'https://salekit.page/assets/images/appexy/avatar1.png' },
      { quote: '"Và vì vậy, chúng tôi trong số họ được giữ bởi một lựa chọn khôn ngoan, đẩy lùi những kẻ khó khăn hơn."', name: 'David Nguyen', role: 'Mobile Developer, VN', avatar: 'https://salekit.page/assets/images/appexy/avatar2.png' },
      { quote: '"Và vì vậy, chúng tôi trong số họ được giữ bởi một lựa chọn khôn ngoan, đẩy lùi những kẻ khó khăn hơn."', name: 'Sarah Tran', role: 'UI/UX Designer, VN', avatar: 'https://salekit.page/assets/images/appexy/avatar3.png' },
    ],
  },
  pricing: {
    label: 'OUR PRICING',
    title: 'Bảng giá',
    subtitle: 'Nhưng để bạn có thể thấy tất cả lỗi này đã phát sinh từ đâu, tôi sẽ mở vấn đề cho những người buộc tội niềm vui và nỗi đau.',
    items: [
      {
        name: 'Miễn phí',
        price: '$0.00',
        period: '/ Tháng',
        features: ['3 Projects', '580GB Storage', 'Unlimited Contacts', '5 Domains', 'Free Support 24/7'],
        buttonText: 'Dùng thử',
        highlighted: false,
      },
      {
        name: 'Pro',
        price: '$29.99',
        period: '/ Tháng',
        features: ['10 Projects', '1.5TB Storage', 'Unlimited Contacts', '12 Domains', 'Free Support 24/7'],
        buttonText: 'Đăng ký',
        highlighted: true,
      },
      {
        name: 'Enterprise',
        price: '$59.99',
        period: '/ Tháng',
        features: ['20 Projects', '2.5TB Storage', 'Unlimited Contacts', '18 Domains', 'Free Support 24/7'],
        buttonText: 'Đăng ký',
        highlighted: false,
      },
    ],
  },
  faq: {
    label: 'OUR FAQS',
    title: 'Các câu hỏi thường gặp',
    subtitle: 'Nhưng để bạn có thể thấy tất cả lỗi này đã phát sinh từ đâu, tôi sẽ mở vấn đề cho những người buộc tội niềm vui và nỗi đau.',
    items: [
      {
        question: 'Thiết bị tại PETPRO đạt những tiêu chuẩn nào?',
        answer: 'Trang thiết bị tại PETPRO tập trung vào tiêu chí mới hiện đại, chính xác và chuyên dùng cho thú nhỏ.',
      },
      {
        question: 'Làm cách nào để tải Ứng dụng dành cho thiết bị di động cho điện thoại của tôi?',
        answer: 'Bạn có thể tải ứng dụng Appexy từ App Store (iOS) hoặc Google Play Store (Android). Tìm kiếm "Appexy" và nhấn "Tải xuống".',
      },
      {
        question: 'Appexy có gì đặc biệt?',
        answer: 'Appexy cung cấp giao diện trực quan, bộ sưu tập thiết kế khổng lồ và khả năng cài đặt bằng một cú nhấp chuột.',
      },
      {
        question: 'Appexy có giá bao nhiêu?',
        answer: 'Appexy có gói miễn phí $0.00/tháng và các gói trả phí bắt đầu từ $29.99/tháng với nhiều tính năng nâng cao.',
      },
    ],
    image: 'https://salekit.page/assets/images/appexy/faq.png',
  },
  contact: {
    title: 'Liên hệ với chúng tôi',
    subtitle: 'OUR CONTACT US',
    description: 'Bạn chỉ cần đăng ký, nhân viên SaleKit sẽ tư vấn trực tiếp và hỗ trợ online 24/7',
    formImage: 'https://salekit.page/assets/images/appexy/contact.png',
  },
  authRegister: {
    title: 'ĐĂNG KÝ HỘI VIÊN',
    subtitle: 'Tham gia Kubet ngay hôm nay',
    phoneLabel: 'SĐT',
    usernameLabel: 'Tài khoản',
    buttonText: 'Đăng ký',
    successMessage: 'Đăng ký thành công! Cảm ơn bạn đã tham gia.',
    errorMessage: 'Có lỗi xảy ra, vui lòng thử lại.',
    bgColor: '#f5f5f5',
    cardBg: '#ffffff',
    borderColor: '#c81d25',
    accentColor: '#c81d25',
    toolbar1: 'WORCUP - Soi kèo bóng đá hàng đầu',
    toolbar2: 'BÓNG ĐÁ - Tỷ lệ kèo nhà cái cập nhật 24/7',
    authLogo: 'https://readdy.ai/api/search-image?query=Kubet%20casino%20official%20brand%20logo%20featuring%20bold%20uppercase%20KU%20letters%20in%20modern%20sans-serif%20font%20with%20orange%20and%20blue%20gradient%20colors%20on%20clean%20transparent%20background%20minimalist%20sports%20betting%20company%20identity%20design&width=300&height=120&seq=kubetlogo1&orientation=landscape',
    authLogoWidth: 280,
    authLogoHeight: 100,
    gSheetUrl: 'https://script.google.com/macros/s/AKfycbyZ5r7b62ETEBD25ughwpMvzOnz8gvu1x7H9674uvw7W0npAz_azKTj6xgZDW7v3N6P/exec',
    // New registration fields
    referralCodeLabel: 'Mã giới thiệu',
    referralCodePlaceholder: 'Bỏ qua nếu không có mã giới thiệu',
    accountLabel: 'Tài khoản',
    accountPlaceholder: '4 ~ 10 ký tự chữ và số',
    nicknameLabel: 'Biệt danh',
    nicknamePlaceholder: 'Nhập tối đa 8 ký tự',
    passwordLabel: 'Mật khẩu',
    passwordPlaceholder: '6 ~ 10 ký tự chữ và số',
    otpButtonText: 'Gửi mã',
    otpPlaceholder: '10 chữ số',
    confirmCodeLabel: 'Mã xác nhận',
    confirmCodePlaceholder: '4 Chữ số',
    confirmCodeButtonText: 'Gửi',
    checkbox1Label: 'Nhận thông tin khuyến mãi qua tin nhắn điện thoại',
    checkbox2Label: 'Tôi đã 18 tuổi, đồng thời đã đọc và đồng ý quy tắc cá cược',
    termsLinkText: 'Điều khoản',
    termsUrl: '#',
    confirmButtonText: 'Xác nhận',
    accountValidationText: 'Tài khoản là tổ hợp 4 ~ 10 ký tự chữ và số',
    passwordShowIcon: 'ri-eye-line',
    passwordHideIcon: 'ri-eye-off-line',
  },
  authLogin: {
    title: 'Đăng nhập',
    subtitle: 'Chào mừng quay trở lại Kubet',
    phoneLabel: 'Số điện thoại',
    usernameLabel: 'Tên đăng nhập',
    buttonText: 'Đăng nhập',
    successMessage: 'Đăng nhập thành công! Chào mừng bạn.',
    errorMessage: 'Có lỗi xảy ra, vui lòng thử lại.',
    bgColor: '#1a1a2e',
    cardBg: '#ffffff',
    borderColor: '#c81d25',
    accentColor: '#c81d25',
    toolbar1: 'WORCUP - Soi kèo bóng đá hàng đầu',
    toolbar2: 'BÓNG ĐÁ - Tỷ lệ kèo nhà cái cập nhật 24/7',
    authLogo: 'https://readdy.ai/api/search-image?query=Kubet%20casino%20official%20brand%20logo%20featuring%20bold%20uppercase%20KU%20letters%20in%20modern%20sans-serif%20font%20with%20orange%20and%20blue%20gradient%20colors%20on%20clean%20transparent%20background%20minimalist%20sports%20betting%20company%20identity%20design&width=300&height=120&seq=kubetlogo1&orientation=landscape',
    authLogoWidth: 280,
    authLogoHeight: 100,
    gSheetUrl: 'https://script.google.com/macros/s/AKfycbyZ5r7b62ETEBD25ughwpMvzOnz8gvu1x7H9674uvw7W0npAz_azKTj6xgZDW7v3N6P/exec',
    referralCodeLabel: '',
    referralCodePlaceholder: '',
    accountLabel: '',
    accountPlaceholder: '',
    nicknameLabel: '',
    nicknamePlaceholder: '',
    passwordLabel: '',
    passwordPlaceholder: '',
    otpButtonText: '',
    otpPlaceholder: '',
    confirmCodeLabel: '',
    confirmCodePlaceholder: '',
    confirmCodeButtonText: '',
    checkbox1Label: '',
    checkbox2Label: '',
    termsLinkText: '',
    termsUrl: '',
    confirmButtonText: '',
    accountValidationText: '',
    passwordShowIcon: 'ri-eye-line',
    passwordHideIcon: 'ri-eye-off-line',
  },
  footer: {
    logo: 'https://salekit.page/assets/images/logo/logo.png',
    address: 'Địa chỉ: 247 Cầu Giấy, Hà Nội',
    phone: '089 898 6008',
    email: 'cskh@salemall.vn',
    links1: ['Giới thiệu', 'Blog', 'Kho giao diện', 'Phần mềm spa'],
    links2: ['Hướng dẫn', 'Nhóm hỗ trợ', 'Đại lý', 'Affiliate', 'Chatbot'],
    appStoreImage: 'https://salekit.page/assets/images/appexy/appstore.png',
    playStoreImage: 'https://salekit.page/assets/images/appexy/playstore.png',
    copyright: '© Salekit - Phần mềm quản lý bán hàng đa kênh - Điều khoản dịch vụ - Chính sách bảo mật',
  },
};